export const managementComparison = [
  {
    category: '관리기구 구성',
    self: '입주자 대표회의에서 직접 구성',
    consignment: '위탁관리업체에서 전문인력으로 구성',
    icon: '👥',
  },
  {
    category: '관리 책임 (법적)',
    self: '입주자 대표 개인이 책임 부담',
    consignment: '위임계약으로 위탁관리업체가 책임 부담',
    icon: '⚖️',
  },
  {
    category: '전문성',
    self: '대표 개인 또는 선임 인력의 경험에 의존 (사후관리)',
    consignment: '인력, 경험, 기술 등 전문성 보유 (예방관리)',
    icon: '🔧',
  },
  {
    category: '행정/회계',
    self: '입대의에서 직접 수행, 회계사고 우려',
    consignment: '위탁사가 수시 검증, 객관성 및 투명성 확보',
    icon: '🧾',
  },
];

export const annualPlan = [
  { month: '1월 ~ 3월 (동절기 및 해빙기)', tasks: ['종합안전진단 및 에너지 절감 실적 분석', '제설작업 및 고사목 정리', '해빙기 안전진단 및 저수조 청소'] },
  { month: '4월 ~ 6월 (춘계)', tasks: ['식목일 식수 및 화초 파종', '오수정화시설 점검 및 청소', '우기 대비 재해방지 대책 수립'] },
  { month: '7월 ~ 9월 (하계)', tasks: ['침수 우려 지역 대비 및 장마 대책 완료', '저수조 청소 및 위생 진단', '보도블럭 및 부동 침하부 보수'] },
  { month: '10월 ~ 12월 (추계 및 동절기)', tasks: ['월동기 안전진단 및 난방설비 점검', '각종 시설물 동파 방지 점검', '차년도 예산서 및 사업계획서 작성'] },
];

export const communityServices = [
  { name: 'Golf', icon: '🏌️‍♂️' }, { name: 'Health', icon: '🏋️‍♀️' }, { name: 'Aerobics', icon: '🤸‍♀️' },
  { name: 'Club House', icon: '🏠' }, { name: 'Sauna', icon: '🧖‍♀️' }, { name: 'Pool', icon: '🏊‍♂️' },
  { name: 'Banquet Hall', icon: '🎉' }, { name: 'Guest Room', icon: '🛌' }
];

export const detailedServiceTabs = [
  {
    id: 'facility',
    title: '시설 관리',
    content: '다수의 랜드마크 주상복합 및 대규모 단지 관리 경험을 보유한 임원진이 완벽한 시설 관리를 약속합니다. 체계적인 시스템과 전문 노하우로 자산의 가치를 높입니다.',
    image: require('@/assets/images/service-facility.jpg')
  },
  {
    id: 'hygiene',
    title: '위생 미화관리',
    content: '쾌적하고 안전한 환경을 위해 선진기술을 도입하고 전문 인력을 양성, 과학적인 클리닝 시스템으로 최상의 환경관리 서비스를 제공합니다.',
    image: require('@/assets/images/service-hygiene.jpg')
  },
  {
    id: 'pest',
    title: '해충방제 소독',
    content: '고가의 약품도 용법과 용량이 적절치 못하면 고객에게 독이 됩니다. 아스톡은 정확한 진단과 스마트 박멸 시스템을 제공합니다.',
    image: require('@/assets/images/service-pest.jpg')
   }
];

export const consultingProcess = [
  {
    stage: '준공 前',
    title: 'Construction Management',
    icon: '🏗️',
    tasks: ['건설원가절감', '하자 발생 최소화', '건설일정단축'],
    color: 'var(--primary-red)'
  },
  {
    stage: '준공 後',
    title: 'Ability Management',
    icon: '📈',
    tasks: ['효율적인 유지관리', '원활한 Operation', '체계적인 사후관리'],
    color: 'var(--primary-blue)'
  }
];

export const mainServices = [
    { id: 'facility', icon: '⚙️', title: '시설관리', desc: '전기, 기계, 소방, 승강기 상시 점검 및 에너지 효율화 솔루션 제공' },
    { id: 'security', icon: '🛡️', title: '보안관리', desc: '24시간 무결점 보안 및 지능형 주차 관제, 내방객 의전 서비스' },
    { id: 'cleaning', icon: '✨', title: '위생미화', desc: '호텔식 클리닝 시스템 적용 및 대리석/화강석 특수 광택 관리' },
    { id: 'pest', icon: '🦟', title: '해충방제', desc: '독자적 아스톡 에어졸 솔루션을 활용한 스마트 박멸 시스템', link: 'http://www.astoc.kr' },
    { id: 'community', icon: '👨‍👩‍👧‍👦', title: '커뮤니티', desc: '입주민의 Needs에 맞춘 고품격 커뮤니티 시설 운영 및 활성화' },
    { id: 'consulting', icon: '🔬', title: '기술컨설팅', desc: '준공 전 설계 검토부터 준공 후 건물 가치 상승 솔루션 제공' },
    { id: 'pm', icon: '💼', title: '임대관리', desc: '임대차 계약, 임대료 징수, Tenant 관리 등 전문적인 자산 관리' },
    { id: 'finance', icon: '📊', title: '재무관리', desc: '투명한 회계 처리 및 자금 관리, 정기적인 재무 보고 서비스' },
];